import React, { useEffect, useState } from "react";
import { Select, Input, Button, Space } from "antd";

type EquationTerm = {
  type: "operator" | "metric" | "numeric";
  value: string;
  mType?: string;
};

type Equation = EquationTerm[];

type Props = {
  m?: string[];
  onSubmit: (equation: Equation, id?: string | null) => void;
  equation?: Array<any>;
  id?: string | null;
};

const operators = ["+", "-", "*", "/", "(", ")"];

const mTypeOptions = [
  { label: "LTM/TTM", value: "ltm" },
  { label: "Quarter (last)", value: "ql" },
  { label: "Annual", value: "a" },
  { label: "Year end figure", value: "al" },
];

const termTypeOptions = [
  { label: "Operator", value: "operator" },
  { label: "Metric", value: "metric" },
  { label: "Numeric", value: "numeric" },
];

const EquationBuilder: React.FC<Props> = ({
  m = [],
  onSubmit,
  equation = Array<any>,
  id = null,
}) => {
  const metrics = [...m, ...operators];
  const metricOptions = metrics.map((metric) => ({
    label: metric,
    value: metric.toLocaleLowerCase(),
  }));

  const [mType, setMType] = useState<string>("");
  const [terms, setTerms] = useState<Array<any>>(equation);

  const handleAddTerm = (type: EquationTerm["type"]) => () => {
    console.log("type", type);
    const newTerm: EquationTerm = {
      type,
      value: type === "operator" ? "" : metrics[0], 
      mType: type === "metric" ? "ltm" : "",
    };
    setTerms([...terms, newTerm]);
  };

  const handleRemoveTerm = (index: number) => () => {
    const newTerms = [...terms];
    newTerms.splice(index, 1);
    setTerms(newTerms);
  };

  const handleUpdateTerm =
    (index: number, field: keyof EquationTerm) => (value: string) => {
      console.log("index:", index, "field:", field, "value:", value);
      const newTerms: any = [...terms];
      newTerms[index][field] = value;
      if (value === "metric") {
        newTerms[index]["mType"] = "ltm";
        newTerms[index]["value"] = metrics[0];
      }
      console.log("newTerms", newTerms);
      setTerms(newTerms);
    };

  const handleUpdateTermInput =
    (index: number, field: keyof EquationTerm) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleUpdateTerm(index, field)(event.target.value);
    };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    console.log("t", terms);
    onSubmit(terms, id);
  };

  useEffect(() => {
    setTerms(equation);
  }, [equation]);

  useEffect(() => {
    console.log("t", terms);
  }, [terms]);

  return (
    <form onSubmit={handleSubmit} className="w-full">
      {terms && terms.length
        ? terms.map((term: any, index: number) => (
            <Space key={index} className="flex mb-4" align="center">
              <Select
                value={term.type}
                onChange={handleUpdateTerm(index, "type")}
                className="w-40"
                options={termTypeOptions}
              />
              {["operator", "numeric"].includes(term.type) ? (
                <Input
                  id="operator"
                  type="text"
                  value={term.value}
                  onChange={handleUpdateTermInput(index, "value")}
                  className="w-full"
                />
              ) : (
                <Select
                  value={term.value}
                  onChange={handleUpdateTerm(index, "value")}
                  className="w-full min-w-[180px]"
                  options={metricOptions}
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              )}
              {term.type === "metric" ? (
                <Select
                  value={term.mType}
                  onChange={handleUpdateTerm(index, "mType")}
                  className="w-full min-w-[160px]"
                  options={mTypeOptions}
                />
              ) : null}
              <Button
                danger
                size="small"
                type="default"
                htmlType="button"
                onClick={handleRemoveTerm(index)}
              >
                Remove
              </Button>
            </Space>
          ))
        : null}
      <div className="flex justify-between mb-4">
        <Button htmlType="button" onClick={handleAddTerm("operator")}>
          Add operator
        </Button>
        <Button htmlType="button" onClick={handleAddTerm("numeric")}>
          Add numeric
        </Button>
        <Button htmlType="button" onClick={handleAddTerm("metric")}>
          Add metric
        </Button>
      </div>
      <Button type="primary" htmlType="submit">
        Save
      </Button>
    </form>
  );
};

export default EquationBuilder;
